
import React, { useEffect, useState } from 'react';
import { auth, db } from '../FirebaseComp/firebase';
import { doc, getDoc } from 'firebase/firestore';
import './userprofile.css';

function UserProfile() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchUserData = async () => {
      const currentUser = auth.currentUser;
      if (currentUser) {
        try {
          const userRef = doc(db, 'users', currentUser.uid);
          const docSnap = await getDoc(userRef);
          if (docSnap.exists()) {
            setUser(docSnap.data());
          } else {
            console.log("No such document!");
          }
        } catch (error) {
          console.error("Error fetching user data:", error);
        } finally {
          setLoading(false);
        }
      }
    };
    fetchUserData();
  }, []);

  if (loading) {
    return <div className="loading-message">Loading your profile...</div>;
  }

  return (
    <div className="user-profile-wrapper">
      <section className="hero">
        <div className="hero-content">
          <h1>Optica International</h1>
          <p>
            The largest eye care network in Sri Lanka. Save on purchases, 
            upgrade your practice, and grow your business with advanced optical 
            technology and professional support for modern eye clinics.
          </p>
        </div>
        <div className="hero-image">
          <img src="/navbar-logo.png" alt="Optica International" />
        </div>
      </section>

      <div className="user-profile-container">
        <div className="profile-image-container">
          <img 
            src={user?.profileImage || "/default-avatar.png"} 
            alt="User Profile" 
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = "/user.png";
            }}
          />
        </div>
        
        <h2 className="user-profile-header">My Profile</h2>
        
        {user ? (
          <div className="user-info">
            <div className="user-info-item">
              <strong>Full Name</strong>
              <span>{user.name || 'Not provided'}</span>
            </div>
            
            <div className="user-info-item">
              <strong>Email Address</strong>
              <span>{user.email || 'Not provided'}</span>
            </div>
            
            <div className="user-info-item">
              <strong>Contact Number</strong>
              <span>{user.contactNo || 'Not provided'}</span>
            </div>
            
            {user.country && (
              <div className="user-info-item">
                <strong>Country</strong>
                <span>{user.country}</span>
              </div>
            )}
            
            {user.memberSince && (
              <div className="user-info-item">
                <strong>Member Since</strong>
                <span>{user.memberSince}</span>
              </div>
            )}
          </div>
        ) : (
          <div className="user-info">
            <p className="loading-message">Welcome to Optica International!</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default UserProfile;